/*
 * "Buy again" on Rivo's order page.
 * Design: Figma "NOM (all)" 8309-80939.
 *
 * Rivo puts the button at the foot of the order's button list, below the
 * addresses; the design puts it in the line item, under the product's colour
 * and size. Everything else on that page is a matter of styling and lives in
 * assets/rivo-account-orders.css — this file exists only because the button
 * has to change parents, which CSS cannot do.
 *
 * Two things it deliberately does not do:
 *
 *   - It never shows a hidden button. Whether "Buy again" appears at all is
 *     Rivo's decision (the app setting behind order_buy_again_enabled, plus
 *     its own checks on the order); a button Rivo hid stays hidden.
 *   - It leaves orders of several products alone. The design only draws a
 *     single-item order, and one button that reorders the whole order would
 *     read as belonging to whichever product it sat under.
 */
(function () {
  var PAGE = '.rivo-order-details-page';

  /* Rivo's own binding, which names the translation key. Steadier than the
     label, which changes with the shopper's language. */
  var BUTTON = '.rivo-aw-ctas a.button[rivo-ax-text*="order_buy_again_button_text"]';

  var MARKER = 'data-nom-buy-again';

  function move() {
    var page = document.querySelector(PAGE);
    if (!page) return;

    var button = page.querySelector(BUTTON);
    if (!button || window.getComputedStyle(button).display === 'none') return;

    var items = page.querySelectorAll('.rivo-aw-order-item');
    if (items.length !== 1) return;

    /* Rivo re-renders the button list on navigation, so a button moved on an
       earlier pass may be a stale copy of the one just found. */
    var previous = items[0].querySelector('[' + MARKER + ']');
    if (previous) previous.remove();

    button.setAttribute(MARKER, '');
    items[0].appendChild(button);
  }

  function start() {
    move();

    var content = document.querySelector('.rivo-slideout__content');
    if (!content) return;

    /*
     * Safe against a loop: the append itself fires the observer, and on the
     * next pass the button is no longer inside .rivo-aw-ctas, so the selector
     * finds nothing and move() returns.
     */
    new MutationObserver(move).observe(content, { childList: true, subtree: true });
  }

  document.addEventListener('rivo-accounts:loaded', start);

  var tries = 0;
  var poll = window.setInterval(function () {
    tries += 1;
    if (document.querySelector('.rivo-slideout__content')) {
      window.clearInterval(poll);
      start();
      return;
    }
    /* ~10s. Past that Rivo is not on this page and there is nothing to wait for. */
    if (tries > 40) window.clearInterval(poll);
  }, 250);
})();
